import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    RangeSlider,
    RangeSliderTrack,
    RangeSliderFilledTrack,
    RangeSliderThumb
} from '@chakra-ui/react'
import {pxToRem} from '../../../utills/pxToRem'

const SliderRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const priceRange = filter.values[0].value
    const [minPrice, maxPrice] = priceRange
        .match(/\(?(\d+)\.\.(\d+)\)?/)
        .slice(1)
        .map(Number)
    const [range, setRange] = useState([minPrice, maxPrice])

    // Reset slider if selectedFilters is empty
    useEffect(() => {
        if (selectedFilters.length === 0) {
            setRange([minPrice, maxPrice])
        }
    }, [selectedFilters, minPrice, maxPrice])

    const updatePriceFilter = ([newMin, newMax]) => {
        const updatedFilter = {
            ...filter.values[0],
            value: `(${newMin - 0.01}..${newMax + 0.01})`
        }
        toggleFilter(updatedFilter, filter.attributeId, false, false)
    }

    function getSliderStep(min, max) {
        const range = max - min
        if (range <= 25) return 1
        if (range <= 100) return 2
        if (range <= 300) return 5
        if (range <= 800) return 10
        return 20
    }
    const step = getSliderStep(minPrice, maxPrice)

    const priceFormatter = (value) => {
        return Number(value).toLocaleString(undefined, {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })
    }

    return (
        <>
            <Box pr={10} pl={2} py={1}>
                <RangeSlider
                    aria-label="price-range-slider"
                    value={range}
                    min={minPrice}
                    max={maxPrice}
                    step={step}
                    onChange={setRange}
                    onChangeEnd={updatePriceFilter}
                    size="sm"
                >
                    <RangeSliderTrack bg="black" height={pxToRem(2)}>
                        <RangeSliderFilledTrack bg="cav_calltoaction_darkred" />
                    </RangeSliderTrack>
                    <RangeSliderThumb
                        index={0}
                        bg="cav_calltoaction_darkred"
                        boxSize={pxToRem(7)}
                    />
                    <RangeSliderThumb
                        index={1}
                        bg="cav_calltoaction_darkred"
                        boxSize={pxToRem(7)}
                    />
                </RangeSlider>
            </Box>
            <Flex justify="space-between">
                <Box textAlign="left" flex="1">
                    <Text>{priceFormatter(range[0])}</Text>
                </Box>
                <Box textAlign="right" flex="1">
                    <Text>{priceFormatter(range[1])}</Text>
                </Box>
            </Flex>
        </>
    )
}

SliderRefinements.propTypes = {
    filter: PropTypes.shape({
        values: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string.isRequired
            })
        ).isRequired,
        attributeId: PropTypes.string.isRequired
    }).isRequired,
    toggleFilter: PropTypes.func.isRequired,
    selectedFilters: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default SliderRefinements
